import React from 'react';
import { BRAND_COPY_DEFAULTS } from '../content/pageCopyDefaults';

const DEFAULT_LOGO_PATH = BRAND_COPY_DEFAULTS.logo_url;

const LEGACY_LOGO_PATHS = new Set([
  '/saloni-logo.svg',
  '/saloni-logo-new.png',
]);

function resolveBrandLogoSrc(src) {
  const path = String(src || '')
    .trim()
    .split('?')[0]
    .toLowerCase();
  if (!path || path === DEFAULT_LOGO_PATH.toLowerCase() || LEGACY_LOGO_PATHS.has(path)) {
    return DEFAULT_LOGO_PATH;
  }
  if (path.endsWith(DEFAULT_LOGO_PATH.toLowerCase())) {
    return DEFAULT_LOGO_PATH;
  }
  return String(src || '').trim() || DEFAULT_LOGO_PATH;
}

/**
 * Site brand logo — default public/saloni-logo.png (full floral wreath mark).
 */
export default function BrandLogo({
  src,
  alt = 'Saloni Designs',
  className = '',
  size,
  width,
  height,
  loading = 'eager',
  decoding = 'async',
  'aria-hidden': ariaHidden,
  ...imgProps
}) {
  const w = width ?? size ?? 160;
  const h = height ?? size ?? 160;
  const logoSrc = resolveBrandLogoSrc(src);

  return (
    <img
      src={logoSrc}
      alt={alt}
      className={className}
      width={w}
      height={h}
      loading={loading}
      decoding={decoding}
      aria-hidden={ariaHidden || undefined}
      {...imgProps}
    />
  );
}
